module.exports = __webpack_public_path__ + "static/img/homeright1.ba5251c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeright1.png
// module id = mrAy
// module chunks = 13